import moment from 'moment';

// Lightweight AuditLog entity wrapper with PascalCase fields only.
// Corresponds to WaveWise.WebApp.Models.Responses.AuditLog.
export default class AuditLog {
  constructor(data) {
    this.Id = data.Id;
    this.UserId = data.UserId || 0;
    this.Tag = data.Tag || '';
    this.Message = data.Message || '';

    // Handle timestamp fields with moment.js.
    if (data.Timestamp !== undefined) {
      this.Timestamp = (data.Timestamp === null) ? null
        : moment.isMoment(data.Timestamp) ? data.Timestamp
        : moment.utc(data.Timestamp);
    }
  }

  // Return formatted local time string for display.
  getFormattedTimestamp() {
    return this.Timestamp ? this.Timestamp.local().format('L LTS') : '';
  }
}
